import { emailRegex, vehicleRegistationRegex, phoneRegex } from "./constants"

export const validateFormRequest = (
  name: string, email: string, message: string, phone: string,
  callback: any, validateMsg = true
) => {
  if (name.trim().length === 0) {
    callback("Please provide your name!")
    return false
  }

  if (!emailRegex.test(email)) {
    callback("Please provide a valid email address!") 
    return false
  }

  if (!phoneRegex.test(phone)) { 
    callback("Please provide a valid phone number!");
    return
  }

  if (validateMsg) {
    if (message.trim().length === 0) {
      callback("Please provide your enquiry message!")
      return false
    }
    if (message.length > 1024) {
      callback("Your message cannot be longer than 1024 characters!")
      return false
    }
  }
  
  return true
}

export const validateTradeinVehicle = (
  regNumber: string, mileage: number | string, condition: string, callback: any,
) => {
  if (!vehicleRegistationRegex.test(regNumber.trim())) {
    callback("The vehicle registration you provided is not valid!")
    return false
  }
  if (!!!`${mileage}`.trim()) {
    callback("Please provide your vehicle's mileage!")
    return false
  }
  if (condition.trim().length === 0) {
    callback("Please provide your vehicle's current condition!")
    return false
  }
  if (condition.length > 1024) {
    callback("Your vehicle condition description cannot be longer than 1024 characters!")
    return false
  }

  return true
}
